import { ReactElement } from 'react'
import { TextureLoader } from 'three'
import { useLoader } from '@react-three/fiber'

/**
 * Below the 2D floorplan image (`FloorplanImage`, z = -0.05) and the floorplan's invisible draw
 * hit target (z = -0.1): the template is the paper everything else lies on.
 */
const PLAN_TEMPLATE_IMAGE_Z = -0.15

export interface PlanTemplateImagePlaneProps {
  url: string
  /** World x range of the plan paper (`getScaledPaperLimits`). */
  xlim: [number, number]
  /** World y range of the plan paper (`getScaledPaperLimits`). */
  ylim: [number, number]
}

/**
 * The plan template rendered to an image, stretched over the plan area: the template page is the
 * paper the export draws on, so its image covers exactly the paper limits the plan area frame
 * marks. Unlit so the colors match the PDF, and never raycast so it can't swallow scene clicks.
 */
const PlanTemplateImagePlane = ({ url, xlim, ylim }: PlanTemplateImagePlaneProps): ReactElement => {
  const texture = useLoader(TextureLoader, url)
  const width = xlim[1] - xlim[0]
  const height = ylim[1] - ylim[0]

  return (
    <mesh
      position={[xlim[0] + width / 2, ylim[0] + height / 2, PLAN_TEMPLATE_IMAGE_Z]}
      raycast={() => null}
    >
      <planeGeometry args={[width, height]} />
      <meshBasicMaterial map={texture} toneMapped={false} />
    </mesh>
  )
}

export default PlanTemplateImagePlane
